export const IS_ANY_OF = 'is any of';
export const FILTER_FIELD_OPERATOR_SEPARATOR = '@';
export const FILTER_OPERATOR_LESS_THAN_OR_EQUAL = 'lessThanOrEqual';
export const FILTER_OPERATOR_GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual';

export const MINUS_SIGN = '-';

export const MAX_SALES_AREAS_COUNT_FOR_PROD_SELECTION = 15;
export const MAX_ADDITIVES_COUNT_FOR_PROD_SELECTION = 8;
export const MAX_BASE_OILS_COUNT_FOR_PROD_SELECTION = 5;
export const MAX_COMPATIBLE_SHEET_COUNT_FOR_PROD_SELECTION = 10;

export const PRODUCT_APPROVAL_INVOICE_UNPAID_DAYS = 14;

export const ANNEX_ENTRANCE_FEE_FILE_NAME = 'Anlage1-Annex1.pdf';
export const REGISTRATION_GUIDELINES_DE = 'Registrierungsleitlinien.pdf';
export const REGISTRATION_GUIDELINES_EN = 'Registration_Guidelines.pdf';
export const TERMS_OF_USE_FILE_NAME = 'Terms_of_Use.pdf';
